// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/**
 * Converts Date|string|number to a Unix timestamp (ms).
 * Falls back to 0 (Jan 1, 1970) if invalid.
 */
export const toTimestamp = (val?: string | number | Date | null): number => {
    if (!val) {
        return 0; // 1970
    }
    const date = new Date(val);
    const timestamp = date.getTime();
    return Number.isNaN(timestamp) ? 0 : timestamp; // fallback to 1970
};
